import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { Component, ElementRef, HostListener, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { User } from '../../../../../../../_base-shared/models/User/User';
import { environment } from '../../../../../environments/environment';
import { MainGlobalEventService } from '../../../../_shared/services/main-global-event.service';
import { UserService } from '../../user.service';

@Component({
  standalone: false,
  selector:    'app-user-signature',
  templateUrl: './user-signature.component.html',
  styleUrls:   ['./user-signature.component.scss']
})
export class UserSignatureComponent implements OnInit {
  @Input() title: string;
  @ViewChild('signaturePad', {static: true}) signaturePad: SignaturePadComponent;

  public signaturePadOptions = {
    minWidth:     1,
    maxWidth:     2,
    canvasWidth:  458,
    canvasHeight: 100,
  };
  public authUser: User;
  public user: User;
  public userId: number      = null;
  public imgPath;
  public signatureImg        = '';
  public prevSignatureImg    = '';
  public isSubmitting        = 0;
  public isLoading           = 0;
  public type: 'readonly' | '';
  public selectedLanguage    = new UntypedFormControl();
  private currentLanguage: 'en' | 'es';
  public storageUrl          = environment.STORAGE_URL + '/';

  constructor(
    private globalEventsService: MainGlobalEventService,
    private elRef: ElementRef,
    private cookieService: CookieService,
    private translate: TranslateService,
    private userService: UserService,
    private toastr: ToastrService,
    private route: ActivatedRoute) {
    this.imgPath = environment.STORAGE_URL + '/';
  }

  ngOnInit(): void {
    this.globalEventsService.authUser$.subscribe(next => {
      this.authUser      = next;
      this.userId        = +this.route.parent.snapshot.paramMap.get('id');
      this.type = (this.userId === this.authUser.id || this.authUser.role.slug === 'super-admin') ? '' : 'readonly';
      const targetUserId = this.userId ? this.userId : this.authUser.id;
      this.getUser(targetUserId);
    });

    const storageLanguage = this.cookieService.get('lang');
    this.currentLanguage  = (storageLanguage === 'es' || storageLanguage === 'en') ? storageLanguage : 'es';
    this.cookieService.set('lang', this.currentLanguage, 365, '/');
    this.selectedLanguage.patchValue(this.currentLanguage);
    this.translate.use(this.currentLanguage);
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    const div = this.elRef.nativeElement.querySelector('.signature-wrap')?.offsetWidth;
    if (div !== 0) {
      this.signaturePad.set('canvasWidth', div);
    }
  }

  drawComplete(): void {
    this.signatureImg = this.signaturePad.toDataURL();
  }

  public clear(signaturePad: SignaturePadComponent): void {
    signaturePad.clear();
    this.signatureImg = '';
    this.prevSignatureImg = '';
  }

  public saveSignature(): void {
    const data = new FormData();
    data.append('signature', this.signatureImg);
    /*data.append('signed_by', this.sign);
    data.append('type', this.type);
    data.append('app_document_id', this.documentId);*/
    this.isSubmitting++;
    this.userService.saveAgentSignature(this.userId, data)
      .pipe(finalize(() => this.isSubmitting--))
      .subscribe(
        next => {
          this.toastr.success(this.translate.instant('SHARED.success'));
        },
        error => this.toastr.error(this.translate.instant('SHARED.error')),
      );
  }

  public getUser(userId: number): void {
    this.isLoading++;
    this.userService.get(userId, {}, ['signature'])
      .pipe(finalize(() => this.isLoading--))
      .subscribe(user => {
        this.user             = user.data;
        this.prevSignatureImg = this.user.signature?.path;
      });
  }
}
